import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';

function PrivacyPolicy() {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          개인정보 처리방침
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Typography variant="body1" paragraph>
            황금거북이(이하 "회사")는 개인정보 보호법에 따라 이용자의 개인정보 보호 및 권익을 보호하고 개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 다음과 같은 처리방침을 두고 있습니다.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            1. 개인정보의 처리 목적
          </Typography>
          <Typography variant="body1" paragraph>
            회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
          </Typography>
          <Typography variant="body1" component="div" paragraph sx={{ pl: 2 }}>
            - 회원 가입 및 관리: 회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증<br />
            - 서비스 제공: 황금거북이 리워드 서비스 제공, 리워드 관리, 출금 처리<br />
            - 고충 처리: 민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락·통지
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            2. 개인정보의 처리 및 보유기간
          </Typography>
          <Typography variant="body1" paragraph>
            회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.
          </Typography>
          <Typography variant="body1" paragraph>
            각각의 개인정보 처리 및 보유 기간은 다음과 같습니다:
          </Typography>
          <Typography variant="body1" component="div" paragraph sx={{ pl: 2 }}>
            - 회원 가입 및 관리: 회원 탈퇴 시까지<br />
            - 재화 또는 서비스 제공: 재화·서비스 공급완료 및 요금결제·정산 완료 시까지<br />
            - 전자상거래에서의 계약·청약철회 등에 관한 기록: 5년
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            3. 처리하는 개인정보의 항목
          </Typography>
          <Typography variant="body1" paragraph>
            회사는 다음의 개인정보 항목을 처리하고 있습니다:
          </Typography>
          <Typography variant="body1" component="div" paragraph sx={{ pl: 2 }}>
            - 필수항목: 이메일, 비밀번호, 닉네임, 전화번호<br />
            - 선택항목: 프로필 이미지<br />
            - 자동수집항목: IP주소, 쿠키, 서비스 이용 기록, 접속 로그
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            4. 개인정보의 제3자 제공
          </Typography>
          <Typography variant="body1" paragraph>
            회사는 원칙적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만, 다음의 경우에는 예외로 합니다:
          </Typography>
          <Typography variant="body1" component="div" paragraph sx={{ pl: 2 }}>
            - 이용자가 사전에 동의한 경우<br />
            - 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            5. 개인정보의 파기
          </Typography>
          <Typography variant="body1" paragraph>
            회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            6. 정보주체의 권리·의무 및 행사방법
          </Typography>
          <Typography variant="body1" paragraph>
            이용자는 개인정보주체로서 다음과 같은 권리를 행사할 수 있습니다:
          </Typography>
          <Typography variant="body1" component="div" paragraph sx={{ pl: 2 }}>
            - 개인정보 열람 요구<br />
            - 오류 등이 있을 경우 정정 요구<br />
            - 삭제 요구<br />
            - 처리정지 요구
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            7. 개인정보 보호책임자
          </Typography>
          <Typography variant="body1" paragraph>
            회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
          </Typography>
          <Typography variant="body1" component="div" paragraph sx={{ pl: 2 }}>
            개인정보 보호책임자<br />
            - 이메일: privacy@example.com<br />
            - 전화번호: 02-1234-5678
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            8. 개인정보 처리방침의 변경
          </Typography>
          <Typography variant="body1" paragraph>
            이 개인정보 처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mt: 4, textAlign: 'center' }}>
            최종 수정일: {new Date().toLocaleDateString('ko-KR')}
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}

export default PrivacyPolicy;
